import React, { useEffect, useState } from "react";
import { Descriptions, Table, Tag, Typography } from "antd";
import { getLeaveRequestDetailApi } from "../../apiservice/hrpayroll";

const { Text } = Typography;

const STATUS_COLORS = { pending: "blue", approved: "green", rejected: "red", cancelled: "default" };

function formatLeaveType(value) {
  if (!value) return "-";
  return value.split("_").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
}

// Self-fetching preview shown inside the approval decision modal — same role
// this plays for Purchase Order/Sales Order (PurchaseOrderVoucherBody /
// SalesOrderVoucherBody), just for the leave_request module.
const LeaveRequestDetail = ({ leaveRequestId }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!leaveRequestId) return;
    getLeaveRequestDetailApi(leaveRequestId)
      .then((res) => setData(res?.data?.data || null))
      .catch(() => setData(null));
  }, [leaveRequestId]);

  if (!data) return null;

  const attendanceColumns = [
    { title: "Date", dataIndex: "attendance_date", render: (v) => (v ? new Date(v).toLocaleDateString() : "-") },
    {
      title: "Status", dataIndex: "status",
      render: (v) => <Tag color={STATUS_COLORS[v] || "default"}>{formatLeaveType(v)}</Tag>,
    },
  ];

  return (
    <div>
      <Descriptions bordered size="small" column={2} style={{ marginBottom: 12 }}>
        <Descriptions.Item label="Employee" span={2}>{data.employee_name || data.emp_id}</Descriptions.Item>
        <Descriptions.Item label="Leave Type">{formatLeaveType(data.leave_type)}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color={STATUS_COLORS[data.status] || "default"}>{formatLeaveType(data.status)}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="From Date">{data.from_date}</Descriptions.Item>
        <Descriptions.Item label="To Date">{data.to_date}</Descriptions.Item>
        {data.current_stage && (
          <Descriptions.Item label="Current Stage" span={2}>{data.current_stage.label}</Descriptions.Item>
        )}
        <Descriptions.Item label="Notes" span={2}>{data.notes || <Text type="secondary">-</Text>}</Descriptions.Item>
      </Descriptions>
      {Array.isArray(data.attendance) && data.attendance.length > 0 && (
        <Table
          rowKey="att_d_id"
          size="small"
          pagination={false}
          columns={attendanceColumns}
          dataSource={data.attendance}
        />
      )}
    </div>
  );
};

export default LeaveRequestDetail;
